import { PRODUCT } from '../../types/product.js';
import { validateProduct } from '../../validators/validateProduct.js';
import { syncConnectorRegistry } from '../sync/syncConnectorRegistry.js';
/**
 * Product fields written by the legacy catalog sync (spec 0035 §D2).
 *
 * Origin owns these fields: the select overwrites on every sync that changes the
 * product. Flags set by hand in SysColect (`stockControlEnabled`,
 * `stockControlByLot`, `stockHasExpiry`, `stockControlByVolume`) are undone on
 * the next sync that writes the row. A select that omits a column leaves
 * `undefined` in the mapper → `pickOwnedFields` skips it → SysColect value is
 * preserved.
 *
 * §C4 — intentionally NOT owned (SysColect FKs; ERP ids would not match):
 * `productGroupId`, `brandId`, `defaultSupplierId`.
 * Unlocked when Brand / ProductGroup / Party have their own connectors and
 * ExternalRef can translate external id → localId on write (0139 §C4-bis).
 */
export const PRODUCT_SYNC_OWNED_FIELDS = [
    'code',
    'reference',
    'barcode',
    'description',
    'unit',
    'ncm',
    'salePrice',
    'purchasePrice',
    'unitWeight',
    'grossWeight',
    'imageUrl',
    'grammage',
    'active',
    'stockControlEnabled',
    'stockControlByLot',
    'stockHasExpiry',
    'stockControlByVolume',
];
/**
 * Keys produced by {@link toProduct} that must stay OUT of ownedFields until §C4-bis.
 * Listed explicitly so a parity test fails if someone "fixes" them back in.
 */
export const PRODUCT_SYNC_FK_EXCLUSIONS = [
    'productGroupId',
    'brandId',
    'defaultSupplierId',
];
export const productSyncConnector = {
    key: 'vh:data-product',
    label: 'Produtos',
    entity: PRODUCT,
    ownedFields: PRODUCT_SYNC_OWNED_FIELDS,
    validate: validateProduct,
    lifecycle: true,
    versioned: true,
};
/** Registers the product connector (idempotent overwrite). */
export function registerProductSyncConnector() {
    syncConnectorRegistry.register(productSyncConnector);
}
//# sourceMappingURL=product.connector.js.map